import type { Env } from '@sparklayer-io/spark-dash-core/context/env-context';
import { type OnboardingStepKey, onboardingStepKeys } from './onboarding-steps';

/**
 * The `?expand=` query value for each step - a public contract other features link to directly
 * (e.g. the price-list assign flow deep-links to `?expand=pricing&precheckPricing=1`), so these
 * exact strings must stay stable.
 */
export const SECTION_TO_STEP: Record<string, OnboardingStepKey> = {
  connect: 'onboarding_platform',
  widgets: 'onboarding_frontend',
  pricing: 'onboarding_sync',
  'customer-groups': 'onboarding_settings',
  launch: 'onboarding_launch',
};

/** The first step (in display order) that isn't complete yet, or null once they all are. */
export function firstIncompleteStep(env: Env): OnboardingStepKey | null {
  return onboardingStepKeys(env).find((key) => !env[key]) ?? null;
}
